export class FilterAreas {
    description!: string;
}